import { createContext } from "react";

export interface ShowSuccessToastType {
  open: boolean;
  successMessage: string;
  successTitle: string;
}

interface InitialStateType {
  showSuccessToastState: ShowSuccessToastType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showSuccessToastSetState: any;
}

const ShowSuccessToastContext = createContext<InitialStateType[]>([]);

export default ShowSuccessToastContext;
